// constants.ts
export const Constants = {
  // PERMISSÕES
  PERMISSAO_CONVIDAR_PARCEIROS: 1,
  PERMISSAO_VER_HIERARQUIA: 2,
  PERMISSAO_EDITAR_COMISSAO: 3,
  PERMISSAO_EDITAR_PERMISSOES: 4,
  PERMISSAO_EDITAR_VENDEDOR_CERTIFICADO: 5,
} as const;

export type Constants = typeof Constants[keyof typeof Constants];
